import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import * as sha512 from 'js-sha512';
import { Subscription, forkJoin } from 'rxjs';
import { Md5 } from 'ts-md5/dist/md5';
// import * as xml2js from 'xml2js';
import { ProductsService } from 'src/app/products.service';
import { LoginService } from 'src/app/login.service';
import { HttpService } from 'src/app/http.service';
// import { HttpClient } from '@angular/common/http';
import { NewsandeventsService } from 'src/app/newsandevents.service';
// import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

// const httpOptions = {
//   headers: new HttpHeaders({
//     'Content-Type': 'application/x-www-form-urlencoded',
//   }),
//   responseType: 'text' as const,
// };
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  environment = environment;
  headersearch: string;

  screenWidth: number;

  localuser: any;

  // Login fields
  custId: string;
  cd: any;
  password: string;
  pd: any;
  rememberme: boolean;

  // Error and success messages: For status codes
  success: string; // Status code '000'
  error: string;

  rssfeed: any;

  microsite1url: string;
  pn1 = ['D08-00-043'];
  microsite2url: string;
  pn2 = ['D08-00-042'];

  event = {
    imgsrc: 'SCTE_2021_3x3.png',
    link: '',
    description: 'Cable-Tec Expo',
    booth: 'Booth #941'
  };

  brochure: any;

  subs: Subscription[] = [];

  productcards = null;
  previousproductcards = null;

  constructor(
    public _router: Router,
    public _loginService: LoginService,
    public _httpService: HttpService,
    // private _http: HttpClient,
    public _productsService: ProductsService,
    public _newsandeventsService: NewsandeventsService,
    private el: ElementRef,
    ) {
    }
  // ngAfterViewInit(): void {
  //   // this.onWindowScroll();
  // }

    // @HostListener('window:scroll', [])
    // onWindowScroll(): void {
    //   // console.log(document.documentElement.scrollTop );
    //   // if(document.getElementById('fixedform')){
    //   //   const element1 = document.getElementById('fixedform');
    //   //   if (document.documentElement.scrollTop === 0) {
    //   //     element1.className = 'font-weight-normal d-none d-md-block border vx-bg-primary p-1 invisible';
    //   //   } else if (document.documentElement.scrollTop <= 30) {
    //   //     element1.className = 'font-weight-normal d-none d-md-block border vx-bg-primary p-1 semiinvisible';
    //   //   } else {
    //   //     element1.className = 'font-weight-normal d-none d-md-block border vx-bg-primary p-1';
    //   //   }
    //   // }
    //   const element = document.getElementById('fixedbutton');
    //   if (document.documentElement.scrollTop === 0) {
    //     element.className = 'font-weight-normal d-none d-md-block border vx-bg-primary p-1 invisible';
    //   } else if (document.documentElement.scrollTop <= 30) {
    //     element.className = 'font-weight-normal d-none d-md-block border vx-bg-primary p-1 semiinvisible';
    //   } else {
    //     element.className = 'font-weight-normal d-none d-md-block border vx-bg-primary p-1';
    //   }
    // }

  ngOnInit(): void {
    // this.getTheFeed();
    // this.getmicrositeURL();
  }

  clickProductLoad() {
    console.log('curr');
    this.productcards = this._productsService.productcards;
  }
  clickPrevProductLoad() {
    console.log('prev');
    this.previousproductcards = this._productsService.previousproductcards;
  }


  loadLogin(){
    if(!this._loginService.user.accepted){
      this._loginService.getRememberMe();
      
      this.error = '';
      this.success = '';
      this.rememberme = true;
      if (localStorage.getItem('login')) {
        this.localuser = JSON.parse(localStorage.getItem('login'));
        this.cd = this.localuser.mid;
        this.pd = this.localuser.mpwd;
      }
    }
  }

  submitSearch(event): void {
    event.preventDefault;
    this._router.navigate(['/search'], { queryParams: { q: this.headersearch }, queryParamsHandling: 'merge' }).then(()=>{
      this.headersearch = '';
    });
    const modalElement = this.el.nativeElement.querySelector('.navbar-collapse.collapse.show');
    if (modalElement) {
      const menuId = document.getElementById('togglenav');
      
      menuId.click();
    }
    // setTimeout(() => {
    //   this.headersearch = '';
    //   const element = document.getElementById('togglenav');
    //   element.click();
    // }, 200);
  }

  // getmicrositeURL(): void {
  //   if(!this.microsite1url || !this.microsite2url){
  //     this.subs.push(this._httpService.getSingleDownload(this.pn1).subscribe((data) => {
  //       if (data.result['Technical Notes']) {
  //         const microsite = data.result['Technical Notes'];
  //         this.microsite1url = microsite[0].url;
  //       }
  //     }));
  //     this.subs.push(this._httpService.getSingleDownload(this.pn2).subscribe((data) => {
  //       if (data.result.Brochure) {
  //         const microsite = data.result.Brochure;
  //         this.microsite2url = microsite[0].url;
  //       }
  //     }));
  //   }
  // }

  getmicrositeURL(): void {
    if (!this.microsite1url || !this.microsite2url) {
      const request1 = this._httpService.getSingleDownload(this.pn1);
      const request2 = this._httpService.getSingleDownload(this.pn2);

      const subscription = forkJoin([request1, request2]).subscribe(([data1, data2]: any) => {
        if (data1.result['Technical Notes']) {
          const microsite = data1.result['Technical Notes'];
          this.microsite1url = microsite[0].url;
        }
        if (data2.result['Brochure']) {
          const microsite = data2.result['Brochure'];
          this.microsite2url = microsite[0].url;
        }
      });

      this.subs.push(subscription);
    }
  }

  getTheFeed(): void {
    if(!this.rssfeed){
      this.subs.push(this._newsandeventsService.getprs().subscribe((data: any) => {
      console.log(data.PressReleases);
      this.rssfeed = data.PressReleases;
      this.subs.pop(); // Remove the subscription from the array
    }));
    }
  }

  // public convertToJson(data: string): void {
  //   const res = [];
  //   // console.log(data);
  //   xml2js.parseString(data, { explicitArray: false }, (error, result) => {
  //     if (error) {
  //       throw new Error(error);
  //     } else {
  //       // res = result.rss.channel.item;
  //       // console.log(res);
  //       // console.log('RSS', result.rss.channel.item);
  //       for (let i = 0; i < 5; i++) {
  //         res.push(result.rss.channel.item[i]);
  //       }
  //     }
  //   });
  //   this.rssfeed = res;
  //   console.log('RSS1', this.rssfeed);
  // }

  loginButton(): void {
    if (!this.custId || !this.password) {
      this.error = 'Please enter your username and/or password.'; // Status code '002'
    } else {
      this.cd = Md5.hashStr((this.custId).toUpperCase());
      this.pd = Md5.hashStr((this.password).toLowerCase());
      const loginCredentials = {
        type: 'login',
        id: this.custId,
        mid: this.cd,
        spwd: sha512.sha512(this.password),
        mpwd: this.pd
      };
      // console.log(loginCredentials);
      this.subs.push(this._loginService.login(loginCredentials).subscribe((data) => {
        // console.log(data);
        if ((data as any).status_code === '000') {
          localStorage.setItem('user', JSON.stringify(data));
          this.success = 'You have successfully logged in.'; // Status code '000'
          this.error = '';
          this._loginService.loginAccepted();
          if (this.rememberme) {
            this._loginService.rememberMe();
            // console.log('REMEMBERED');
          }
          setTimeout(() => {
            this.success = '';
            this.custId = '';
            this.password = '';
          }, 500);
        } else if ((data as any).status_code === '003') {
          this.error = 'This account has been blocked. Please contact registration@veexinc.com for further support.'; // Status code '003'
          this.success = '';
        } else if ((data as any).status_code === '004') {
          this.error = 'This account is unregistered. Please register your account first by using the registration mail. If you have any questions, please contact registration@veexinc.com for further support.'; // Status code '004'
          this.success = '';
        } else {
          this.error = 'The username and/or password you provided was not found.'; // Status code '001'
          this.success = '';
        }
      }));
    }
  }

  loginmyveex(): void {
    const form0: HTMLFormElement = document.getElementById('veexForm1') as HTMLFormElement;
    // console.log(this.pd);
    // console.log(form0);
    form0.addEventListener('submit', (event) => {
    if (JSON.parse(localStorage.getItem('login'))) {
      this.localuser = JSON.parse(localStorage.getItem('login'));
      this.cd = this.localuser.mid;
      this.pd = this.localuser.mpwd;
    }
    event.preventDefault();
    form0.submit();
    });
    // this._router.navigate(['/company/myveex'], { queryParamsHandling: 'merge' });
  }

  // Clears error and success messages
  resetButton(): void {
    this.error = '';
    this.success = '';
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
  scroll(el: HTMLElement): void {
    const elementPosition = el.getBoundingClientRect().top;
    const offsetPosition = elementPosition - 60;
    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}
}
